import {constructUsing} from 'rlink-collections/symbols';
import {isInstanceOrSubclassOf, isPlainObject} from 'rlink-type-utils';

/**
 * For the given instance or class, returns which iterable
 * value is used in the constructor iterator. One of:
 *   - constructUsing.key
 *   - constructUsing.value
 *   - constructUsing.both
 *
 * @param  {(Collection|Function)} obj
 * @return {Symbol}
 */
export default function constructsUsing (obj) {
  if (isInstanceOrSubclassOf(obj, Array)) {
    return constructUsing.value;
  } else if (isInstanceOrSubclassOf(obj, Map)) {
    return constructUsing.both;
  } else if (isInstanceOrSubclassOf(obj, Set)) {
    return constructUsing.value;
  } else if (isInstanceOrSubclassOf(obj, WeakMap)) {
    return constructUsing.both;
  } else if (isInstanceOrSubclassOf(obj, WeakSet)) {
    return constructUsing.value;
  } else if (isPlainObject(obj)) {
    return constructUsing.both;
  } else {
    return this.NotApplicable;
  }
}



// WEBPACK FOOTER //
// ./lib/rlink-collections/core/constructsUsing.js